/*
 This file is auto-generated, do not edit
*/

'use strict';
const rqs = require('./request');

/**
 * Sets viewed portion of an item (for example a video or article) by a user (at a session).
 * If you send a new request with the same (`userId`, `itemId`, `sessionId`), the portion gets updated.
 */
class SetViewPortion extends rqs.Request {
  /**
   * Construct the request
   * @param {string} userId - User who viewed a portion of the item
   * @param {string} itemId - Viewed item
   * @param {number} portion - Viewed portion of the item (number between 0.0 (viewed nothing) and 1.0 (viewed full item) ). It should be the actual viewed part of the item, no matter the seeking. For example, if the user seeked immediately to half of the item and then viewed 10% of the item, the `portion` should still be `0.1`.
   * @param {Object} optional - Optional parameters given as an object with structure name of the parameter: value
   * - Allowed parameters:
   *     - *sessionId*
   *         - Type: string
   *         - Description: ID of the session in which the user viewed the item. Default is `null` (`None`, `nil`, `NULL` etc., depending on the language).
   *     - *timestamp*
   *         - Type: string | number
   *         - Description: UTC timestamp of the view portion as ISO8601-1 pattern or UTC epoch time. The default value is the current time.
   *     - *cascadeCreate*
   *         - Type: boolean
   *         - Description: Sets whether the given user/item should be created if not present in the database.
   *     - *recommId*
   *         - Type: string
   *         - Description: If this view portion is based on a recommendation request, `recommId` is the id of the clicked recommendation.
   *     - *additionalData*
   *         - Type: object
   *         - Description: A dictionary of additional data for the interaction.
   *     - *autoPresented*
   *         - Type: boolean
   *         - Description: Indicates whether the item was automatically presented to the user (e.g., in a swiping feed) or explicitly requested by the user (e.g., by clicking on a link). Defaults to `false`.
   *     - *timeSpent*
   *         - Type: number
   *         - Description: The duration (in seconds) that the user viewed the item. In update requests, this value may only increase and is required only if it has changed.
   */
  constructor(userId, itemId, portion, optional) {
    super('POST', '/viewportions/', 9000, false);
    this.userId = userId;
    this.itemId = itemId;
    this.portion = portion;
    optional = optional || {};
    this.sessionId = optional.sessionId;
    this.timestamp = optional.timestamp;
    this.cascadeCreate = optional.cascadeCreate;
    this.recommId = optional.recommId;
    this.additionalData = optional.additionalData;
    this.autoPresented = optional.autoPresented;
    this.timeSpent = optional.timeSpent;
  }

  /**
   * Get body parameters
   * @return {Object} The values of body parameters (name of parameter: value of the parameter)
   */
  bodyParameters() {
    const params = {};
    params.userId = this.userId;
    params.itemId = this.itemId;
    params.portion = this.portion;

    if (this.sessionId !== undefined) params.sessionId = this.sessionId;

    if (this.timestamp !== undefined) params.timestamp = this.timestamp;

    if (this.cascadeCreate !== undefined) params.cascadeCreate = this.cascadeCreate;

    if (this.recommId !== undefined) params.recommId = this.recommId;

    if (this.additionalData !== undefined) params.additionalData = this.additionalData;

    if (this.autoPresented !== undefined) params.autoPresented = this.autoPresented;

    if (this.timeSpent !== undefined) params.timeSpent = this.timeSpent;

    params.cascadeCreate = this.cascadeCreate !== undefined ? this.cascadeCreate : true;
    return params;
  }
}

exports.SetViewPortion = SetViewPortion;
